export const OutletData = [
  [
    "outlet_name",
    "outlet_unique_id",
    "outlet_contact_number",
    "customer_code",
    "outlet_category",
    "outlet_ccnoms",
    "outlet_ccnohsd",
    "outlet_contact_person_name",
    "primary_number",
    "secondary_number",
    "primary_email",
    "secondary_email",
    "location",
    "address",
    "outlet_resv",
    "outlet_longitude",
    "outlet_lattitude",
    "status",
    "email",
    "password",
  ],
  [
    "Main Street Outlet", // outlet_name
    "OUT12h346", // outlet_unique_id
    "+1234567890", // outlet_contact_number
    "CUST001", // customer_code
    "Retail", // outlet_category
    500, // outlet_ccnoms
    300, // outlet_ccnohsd
    "John Doe", // outlet_contact_person_name
    "+1987654321", // primary_number
    "+1234567891", // secondary_number
    "primary@example.com", // primary_email
    "secondary@example.com", // secondary_email
    "Downtown Cityville", // location
    "123 Main Street Cityville", // address
    "Yes", // outlet_resv
    "40.712776", // outlet_longitude
    "-74.005974", // outlet_lattitude
    1, // status (active)
    "outlet@example.com", // email
    "securePassword123", // password
  ],
  [
    "Outlet 2", // outlet_name
    "OUT123o56", // outlet_unique_id
    "+1234567890", // outlet_contact_number
    "CUST001", // customer_code
    "Retail", // outlet_category
    500, // outlet_ccnoms
    300, // outlet_ccnohsd
    "John Doe", // outlet_contact_person_name
    "+1987654321", // primary_number
    "+1234567891", // secondary_number
    "primary@example.com", // primary_email
    "secondary@example.com", // secondary_email
    "Downtown Cityville", // location
    "123 Main Street Cityville", // address
    "Yes", // outlet_resv
    "40.712776", // outlet_longitude
    "-74.005974", // outlet_lattitude
    1, // status (active)
    "outlet@example.com", // email
    "securePassword123", // password
  ],
];
export const CompanyData = [
  [
    "company_name",
    "company_type",
    "company_email",
    "company_contact",
    "company_mobile",
    "company_address",
    "company_contact_person",
    "primary_contact_number",
    "primary_contact_email",
    "designation",
    "department",
    "company_website",
    "gst_treatment_type",
    "business_legal_name",
    "business_trade_name",
    "pan_number",
    "gst_number",
    "place_of_supply",
    "my_company",
    "enable_company_type",
    "email",
    "password",
    "gst_number",
    "shipping_address",
    "billing_address",
    "is_default",
  ],
  [
    "Rahul Company New",
    "3",
    "rahulkumar@sartiaglobal.cin	",
    "7658412557",
    "7658412557",
    "C-14 Noida Sector-6",
    "Rahul",
    9313301020,
    "RAHULcompanynew@SARTIAGLOBAL.CIN",
    "web designing",
    "IT",
    "RegisteredBusiness.com",
    "Regular ",
    "Sartia globnal",
    "sartia global",
    "0012qwerty",
    "GST123",
    "delhi",
    "1",
    "1",
    "rahul@gmail.com",
    "123456",
    "comp12ty",
    "noida sector 6",
    "delhi",
    "1",
  ],
];
export const ComplaintData = [
  [
    "energy_company_id",
    "zone_id",
    "ro_id",
    "sale_area_id",
    "district_id",
    "outlet_id",
    "complaint_type",
    "description",
    "order_by_id",
    "order_via_id",
    "work_permit",
    "complaint_for",
  ],
  ["8", "12", "12", "15", "15", "41", "28", "ok", "167", "11", "yes", "1"],
];
export const ItemsData = [
  [
    "name",
    "rates",
    "hsncode",
    "rucode",
    "item_unique_id",
    "description",
    "category",
  ],
  [
    "Bottle",
    "500",
    "HSN1211",
    "RU1159",
    "BOTT122024121",
    "Cello Bottle",
    "fund",
  ],
  [
    "Pen stand",
    "25",
    "HSN1202",
    "RU2024",
    "PENST12112024",
    "Denis Pen stand",
    "stock",
  ],
];
export const POAndSOItemsData = [
  [
    "order_line_number",
    "hsn_code",
    "name",
    "unit",
    "change_gst_type",
    "rate",
    "qty",
    "amount",
    "description",
  ],
  [
    1,
    "HSN001",
    "SURFACE DRESSINGSITE",
    "each",
    "0",
    100,
    2,
    200,
    "Description 1",
  ],
  [
    2,
    "HSN002",
    "EXCAVATIONF/FNDTNBTWN 3-4.5M",
    "meter",
    "0",
    150,
    3,
    450,
    "Description 2",
  ],
  [3, "HSN003", "FNDTNBTWN 3-4.5M", "sqm", "0", 200, 1, 200, "Description 3"],
];
